import { render, staticRenderFns } from "./AutopalData.vue?vue&type=template&id=45cc0b6a&scoped=true&"
import script from "./AutopalData.vue?vue&type=script&lang=js&"
export * from "./AutopalData.vue?vue&type=script&lang=js&"
import style0 from "./AutopalData.vue?vue&type=style&index=0&id=45cc0b6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45cc0b6a",
  null
  
)

export default component.exports